// eslint-disable-next-line import/no-internal-modules
import { css } from 'aphrodite';
import * as React from 'react';
import { useState } from 'react';
import ReactDOM from 'react-dom';
import { Button } from '../../../../web/components/Button';
import { LoadingSpinner } from '../../../../web/components/LoadingSpinner';
import CoffeeAnimationImageUrl from '../../../assets/coffee-animation.gif';
import TysonSplashImageUrl from '../../../assets/tyson-splash.jpg';
import { useTysonMode } from '../../../contexts/tysonMode';
import { CoffeeLogo } from '../../svgs/CoffeeLogo';
import { styleSheet } from '../styles';

interface IProps {
	onClick: () => Promise<boolean> | void;
}

export const SplashScreen: React.FC<IProps> = ({ onClick }) => {
	const [loading, setLoading] = useState(false);
	const { isActive: isTysonModeActive } = useTysonMode();

	const letsGoClick = async (e: React.MouseEvent<HTMLElement>) => {
		e.stopPropagation();
		setLoading(true);
		// Reset if the dialer never came up — a failed token fetch would otherwise leave the
		// spinner here for the rest of the session with no way back to the button.
		const started = await onClick();
		if (!started) setLoading(false);
	};

	const component = (
		<div className={css(styleSheet.splashScreen)} onClick={e => void letsGoClick(e)}>
			{!isTysonModeActive && <CoffeeLogo className={css(styleSheet.splashScreenLogo)} />}
			<img
				className={css(styleSheet.splashScreenImage)}
				src={isTysonModeActive ? TysonSplashImageUrl : CoffeeAnimationImageUrl}
			/>
			<div className={isTysonModeActive ? css(styleSheet.splashScreenButtonContainer) : undefined}>
				{loading ? <LoadingSpinner type='small' /> : <Button onClick={e => void letsGoClick(e)} label="Let's go!" />}
			</div>
		</div>
	);
	const nodeToAppend = document.querySelector('body');

	return ReactDOM.createPortal(component, nodeToAppend);
};
